export default __webpack_public_path__ + "static/media/gsm_4.6695ea9f.svg";